import styled, { css } from 'styled-components'
import { tabletBreakpoint } from 'react-components'

export const Content = styled.div<{ isModal?: boolean; isSortOpen: boolean }>(
    ({ theme, isModal, isSortOpen }) => css`
        display: flex;
        flex-direction: column;
        padding-bottom: ${theme.spacing.medium};
        width: 100%;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            ${!isModal &&
            css`
                display: ${isSortOpen ? 'block' : 'none'};
                position: absolute;
                left: ${theme.spacing.medium};
                padding: ${theme.spacing.large} ${theme.spacing.xxLarge} ${theme.spacing.xSmall} ${theme.spacing.large};
                min-width: 23.125rem;
                top: 2.5rem;
                box-shadow:
                    0 8px 10px #0000000f,
                    0 3px 14px #0000000a,
                    0 5px 5px #00000014;
                border-radius: ${theme.typography.border.radius.small};
                margin-bottom: 0;
                background-color: ${theme.colors.white};
                z-index: 1000;
            `}

            ${isModal &&
            css`
                padding: ${theme.spacing.medium} ${theme.spacing.medium} 0;
            `}
        }
    `,
)
